var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlightVerticalDirect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "108px",
    viewBox: "0 0 12 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B8592387-42ED-44A6-9E5F-2700DA4AA81D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Summary",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-flight-connectors",
    transform: "translate(-22, -227)",
    stroke: "#00A1DE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flightconnector/Vertical/Medium/DirectFlight-Copy-2",
    transform: "translate(22, 227)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -43.5,
    y1: 53.5,
    x2: 55.5,
    y2: 53.5,
    id: "Path",
    strokeWidth: 2,
    transform: "translate(6, 53.5) rotate(90) translate(-6, -53.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    transform: "translate(6, 5) rotate(90) translate(-6, -5)",
    cx: 6,
    cy: 5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#FFFFFF",
    transform: "translate(6, 103) rotate(90) translate(-6, -103)",
    cx: 6,
    cy: 103,
    r: 4.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightVerticalDirect);
export default __webpack_public_path__ + "static/media/flight-vertical-direct.04a8a28a0394c22272bd4b8e67945c0b.svg";
export { ForwardRef as ReactComponent };